var React = require('react');

function XRounded (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M25 7L7 25","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M25 25L7 7","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

XRounded.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = XRounded;

XRounded.default = XRounded;
